<template>
	<div>
    <!-- Main Wrapper -->
		<div class="main-wrapper">
		
			<!-- Header -->
                <layout-header />
			<!-- /Header -->
			
			<!-- Breadcrumb -->
			<div class="breadcrumb-bar">
				<div class="container-fluid">
					<div class="row align-items-center">
						<div class="col-md-12 col-12">
							<nav aria-label="breadcrumb" class="page-breadcrumb">
								<ol class="breadcrumb">
									<li class="breadcrumb-item"><router-link to="/index">Home</router-link></li>
									<li class="breadcrumb-item active" aria-current="page">Manajemen Paket</li>
								</ol>
							</nav>
							<h2 class="breadcrumb-title">Manajemen Paket</h2>
						</div>
					</div>
				</div>
			</div>
			<!-- /Breadcrumb -->
			
			<!-- Page Content -->
			<div class="content">
				<div class="custom-container">

					<div class="row">
						
						<!-- Profile Sidebar -->
						<div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
							<Sidebar />
						</div>
						<!-- / Profile Sidebar -->
						
						<div class="col-md-7 col-lg-8 col-xl-9">
							<div class="card">
								<div class="card-body pt-0">
								
									<!-- Tab Menu -->
									<nav class="user-tabs mb-4">
										<ul class="nav nav-tabs nav-tabs-bottom nav-justified">
											<li class="nav-item">
												<a class="nav-link active" href="#pat_medical_records" data-toggle="tab"><span class="med-records">Manajemen Paket</span></a>
											</li>
											<!-- <li class="nav-item">
												<a class="nav-link" href="#pat_appointments" data-toggle="tab">Semua Kelas</a>
											</li> 
											<li class="nav-item">
												<a class="nav-link" href="#pat_billing" data-toggle="tab">Kalender</a>
											</li> -->
										</ul>
									</nav>
									<!-- /Tab Menu -->
									
									<!-- Tab Content -->
									<div class="tab-content pt-0">
											 
										<!-- Course Records Tab -->
										<div id="pat_medical_records" class="tab-pane fade show active">
											<div class="card card-table mb-0">
												<div class="card-body">
													
                                                    <div class="col-auto text-right float-right ml-auto">
                                                        <a href="#" class="btn btn-primary btn-sm" @click.prevent="getAdd()">Tambah Paket</a>
                                                    </div>
													<div class="table-responsive">
														<table id="tbl" class="table table-hover table-center mb-0">
															<thead>
																<tr>
																	<th>ID</th>
																	<th>Nama Paket</th>
																	<th>Tipe</th>
																	<th>Harga Awal</th>
																	<th>Harga Special</th>
																	<th>Diskon</th>
																	<th>Harga Aktif</th>
																	<th>Masa Berlaku</th>
																	<th>Jumlah Tryout</th>
																	<th>Status</th>
																	<th>Pendaftaran</th>
																	<th>Aksi</th>
																</tr>     
															</thead>
															<tbody>
																<tr v-for="(ref, index) in lstpaket" :key="ref.id_paket">
                                                                    <td>{{ index + 1 }}</td>
                                                                    <td>{{ ref.nama_paket }}</td>
                                                                    <td class="text-center">
    																	<span v-if="ref.tipe_paket == '2'">BIMBEL</span>
																		<span v-else>MANDIRI</span>
																	</td>
                                                                    <td class="text-right">{{ ref.harga_awal }}</td>
                                                                    <td class="text-right">{{ ref.harga_special }}</td>
                                                                    <td class="text-center">{{ ref.hemat }}</td>
                                                                    <td class="text-right">{{ ref.harga_aktif }}</td>
                                                                    <td class="text-center">{{ ref.masa_berlaku }} bulan</td>
                                                                    <td class="text-center">{{ ref.jml_to }} TO</td>
                                                                    <td class="text-center">
    																	<span v-if="ref.fg_publish == '2'">PUBLISH</span>
																		<span v-else>DRAFT</span>
																	</td>	
																	<td class="text-center">
    																	<span v-if="ref.fg_pendaftaran == '1'">DITUTUP</span>
																		<span v-else>DIBUKA</span>
																	</td>																	
                                                                    <td>
                                                                        <v-btn class="btn btn-sm bg-success-light" depressed small @click="getEdit(ref)">
                                                                            <i class="fas fa-edit"></i> Edit
                                                                        </v-btn>
                                                                        <!-- <v-btn class="btn btn-sm bg-info-light" depressed small @click="getJadwal(ref)">
                                                                            <i class="fas fa-edit"></i> Jadwal
                                                                        </v-btn>
                                                                        <v-btn class="btn btn-sm bg-warning-light" depressed small @click="getLdt(ref)">
                                                                            <i class="fas fa-edit"></i> LearnDoTeach
                                                                        </v-btn> -->
                                                                        <v-btn color="btn btn-sm bg-danger-light" depressed small @click="getDelete(ref)">
                                                                            <i class="fas fa-times"></i> Delete
                                                                        </v-btn>
                                                                    </td>
                                                                </tr>
																
															</tbody>  	
														</table>
													</div>
												</div>
											</div>
										</div>
										<!-- /Course Records Tab -->
										
										<!-- Appointment Tab -->
										<div id="pat_appointments" class="tab-pane fade">
											<div class="card">
												<div class="card-body">
                                                    
                                                    <!-- <div class="row row-grid">
                                                        <div class="col-md-6 col-lg-4" v-for="item in instructors" :key="item.id">
                                                            <div class="card widget-profile pat-widget-profile">
                                                                <div class="card-body">
                                                                    <div class="pro-widget-content">
                                                                        <div class="profile-info-widget">
                                                                            <router-link to="/instructor/profile" class="booking-doc-img">
                                                                                <img :src="loadImg(item.image)" alt="User Image">
                                                                            </router-link>
                                                                            <div class="profile-det-info">
                                                                                <h3><router-link to="/instructor/profile">{{item.name}}</router-link></h3>
                                                                                
                                                                                <div class="receiver-details">
                                                                                    <h5><b>Instructor ID :</b> {{item.instructor_id}}</h5>
                                                                                    <h5 class="mb-0"><i class="fas fa-map-marker-alt"></i>{{item.location}}</h5>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div class="receiver-info">
                                                                        <ul>
                                                                            <li>Phone <span>{{item.phone}}</span></li>
                                                                            <li>Age <span>{{item.age}}, {{item.gender}}</span></li>
                                                                            <li>Subject <span>{{item.subject}}</span></li>
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div> -->

												</div>
											</div>
										</div>
										<!-- /Appointment Tab -->
									
										<!-- Billing Tab -->
										<div id="pat_billing" class="tab-pane fade">
											<div class="card card-table mb-0">
												<div class="card-body">
													<div class="table-responsive">
														<table class="table table-hover table-center mb-0">
															<thead>
																<tr>
																	<th>Invoice No</th>
																	<th>School</th>
																	<th>Amount</th>
																	<th>Paid On</th>
																	<th></th>
																</tr>
															</thead>
															<tbody>
																
															</tbody>
														</table>
													</div>
												</div>
											</div>
										</div>
										<!-- /Billing Tab -->
										  
									</div>
									<!-- Tab Content -->
									
								</div>
							</div>
						</div>
					</div>

				</div>

			</div>		
			<!-- /Page Content -->
   
			<!-- Footer -->
                <layout-footer />
			<!-- /Footer -->
		</div>
			
		<div id="addMdl" class="modal custom-modal fade" role="dialog">
			<div class="modal-dialog modal-dialog-centered modal-xl" role="document" style="width:90% !important">
				<div class="modal-content">
					<div class="modal-header">
						<h4 class="modal-title">Tambah Paket</h4>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">

						<!-- <div class="card card-table mb-0">
							<div class="card-body"> -->
								<!-- Tab Menu -->
								<nav class="user-tabs mb-4">
									<ul class="nav nav-tabs nav-tabs-bottom nav-justified">
										<li class="nav-item">
											<a class="nav-link active" href="#informasipaket" data-toggle="tab"><span class="med-records">Info Paket</span></a>
										</li>
										<li class="nav-item" v-if="paket.id_paket">
											<a class="nav-link" href="#attachtryout" data-toggle="tab">Attach Tryout</a>
										</li> 
										<li class="nav-item" v-if="paket.id_paket">
											<a class="nav-link" href="#attachkategori" data-toggle="tab">Attach Kategori</a>
										</li>
									</ul>
								</nav>
								<!-- /Tab Menu -->
								
								<!-- Tab Content -->
								<div class="tab-content pt-0">
											
									<!-- Course Records Tab -->
									<div id="informasipaket" class="tab-pane fade show active">
										<!-- <div class="card card-table">											 -->
											<!-- <div class="card-body">
												<div class="table-responsive"> -->
													<form id="frm">                            
														<div class="row">
															<div class="col-md-6 col-sm-12">
																<div class="form-group card-label">
																	<label>Nama Paket</label>
																	<input class="form-control" type="text" v-model="paket.nama_paket">
																</div>
															</div>
															<div class="col-md-6 col-sm-12">
																<div class="form-group card-label">
																	<label>Tipe</label>
																	<v-select
																	:options="lsttipe"
																	:reduce="lsttipe => lsttipe.id" 
																	label="text"
																	v-model="paket.tipe_paket"
																	/>	
																</div>
															</div>
															<div class="col-md-6 col-sm-12">
																<div class="form-group card-label">
																	<label>Harga Awal</label>
																	<!-- <input class="form-control" type="text" v-model="paket.harga_awal"> -->
																	 <!-- <input type="text" class="form-control" v-model="paket.harga_awal" @keypress="stripTheGarbage($event)" @blur="formatDollars()" required/>
      																 <span class="currency-symbol">$</span> -->
																	 <number class="form-control" v-model="paket.harga_awal" v-bind="number"></number>
																</div>
															</div>
															<div class="col-md-6 col-sm-12">
																<div class="form-group card-label">
																	<label>Diskon Harga </label>
																	 <number class="form-control" v-model="paket.diskon" v-bind="number"></number>
																	<!-- <input class="form-control" type="number" v-model="paket.diskon"> -->
																</div>
															</div>
															<div class="col-md-6 col-sm-12">
																<div class="form-group card-label">
																	<label>Masa Berlaku (bulan)</label>
																	<input class="form-control" type="text" v-model="paket.masa_berlaku">
																</div>
															</div>

															<div class="col-md-6 col-sm-12">
																<div class="form-group card-label">
																	<label>Diskon Referral</label>                                      
																	<input class="form-control" type="text" v-model="paket.diskon_referral">
																</div>
															</div>
															
															<div class="col-md-6 col-sm-12">
																<div class="form-group card-label">
																	<label>Komisi Referral</label>
																	<input class="form-control" type="text" v-model="paket.komisi_referral">
																</div>
															</div>

															<div class="col-md-6 col-sm-12">
																<div class="form-group card-label">
																	<label>URL Gambar</label>
																	<input class="form-control" type="text" v-model="paket.url_gambar">
																</div>
															</div>
															
															
															<div class="col-md-6 col-sm-12">
																<div class="form-group card-label">
																	<label>Status</label>
																	<v-select
																	:options="lststspublish"
																	:reduce="lststspublish => lststspublish.id" 
																	label="text"
																	v-model="paket.fg_publish"
																	/>
																	
																</div>
															</div>

															<div class="col-md-6 col-sm-12">
																<div class="form-group card-label">
																	<label>Status Pendaftaran</label>
																	<v-select
																	:options="lststspendaftaran"
																	:reduce="lststspendaftaran => lststspendaftaran.id" 
																	label="text"
																	v-model="paket.fg_pendaftaran"
																	/>
																	
																</div>
															</div>

															<div class="col-md-6 col-sm-12">
																<div class="form-group card-label">
																	<label>Status Favorit</label>
																	<v-select
																	:options="lststsfav"
																	:reduce="lststsfav => lststsfav.id" 
																	label="text"
																	v-model="paket.fg_favorit"
																	/>
																	
																</div>
															</div>
															
															<div class="col-md-6 col-sm-12">
																<div class="form-group card-label">
																	<label>Status Peringkat</label>
																	<v-select
																	:options="lststspendaftaran"
																	:reduce="lststspendaftaran => lststspendaftaran.id" 
																	label="text"
																	v-model="paket.fg_rank"
																	/>
																	
																</div>
															</div>

															<div class="col-md-6 col-sm-12">
																<div class="form-group card-label">
																	<label>Status Slot</label>
																	<v-select
																	:options="lststspendaftaran"
																	:reduce="lststspendaftaran => lststspendaftaran.id" 
																	label="text"
																	v-model="paket.fg_slot"
																	/>
																	
																</div>
															</div>
															
															<div class="col-md-6 col-sm-12">
																<div class="form-group card-label">
																	<label>Link Telegram</label>
																	<input class="form-control" type="text" v-model="paket.url_telegram">
																</div>
															</div>
															
															<div class="col-md-6 col-sm-12">
																<div class="form-group card-label">
																	<label>Kuota</label>
																	<input class="form-control" type="text" v-model="paket.slot">
																</div>
															</div>

															<div class="col-md-6 col-sm-12">
																<div class="form-group card-label">
																	<label>Kategori</label>
																	<v-select
																	:options="lstkat"
																	:reduce="lstkat => lstkat.id" 
																	label="nama_kat"
																	v-model="paket.id_kat"                                
																	/>
																</div>
															</div>
															
															<div class="col-md-6 col-sm-12">
																<div class="form-group card-label">
																	<label>Deskripsi Paket</label>
																	<textarea id="review_desc" row="8" class="form-control" v-model="paket.deskripsi"></textarea>
																</div>
															</div>	

															
															<!-- <div class="col-md-6 col-sm-12">
																<div class="form-group card-label">
																	<label>Mitra</label>
																	<v-select
																	:options="lstmitra"
																	:reduce="lstmitra => lstmitra.id_user" 
																	label="namauser"
																	v-model="paket.id_mitra"                                
																	/>
																</div>
															</div>
																									
															 -->
															<div class="col-md-12 col-sm-12">
																<hr>
																<div class="table-responsive">		
																		
																	<h3>BENEFIT PAKET</h3>																
																	<div class="col-auto text-right float-right ml-auto">
																		<a href="#" class="btn btn-primary btn-sm" @click.prevent="addBenefit()">Tambah Benefit</a>
																	</div>
																	<table id="tbl" class="table table-hover table-center mb-0">
																		<thead>
																			<tr>
																				<th>No</th>
																				<th>Benefit</th>
																				<th>Aksi</th>
																			</tr>     
																		</thead>
																		<tbody>
																			<tr v-for="(ref, index) in lstbenefit" :key="ref">
																				<td class="text-center">{{ index + 1 }}</td>
																				<td><input class="form-control" type="text" v-model="ref.nama_benefit"></td>										
																				<td class="text-center">
																					<v-btn color="btn btn-sm bg-danger-light" depressed small @click="deleteBenefit(index)">
																						<i class="fas fa-times"></i> Delete
																					</v-btn>
																				</td>
																			</tr>
																			
																		</tbody>  	
																	</table>																	
																</div>
															</div>

															
															<div class="col-md-12 col-sm-12">
																<hr>
																<div class="table-responsive">		
																		
																	<h3>KATEGORI PAKET</h3>																
																	<div class="col-auto text-right float-right ml-auto">
																		<a href="#" class="btn btn-primary btn-sm" @click.prevent="addKategori()">Tambah Kategori</a>
																	</div>
																	<table id="tbl" class="table table-hover table-center mb-0">
																		<thead>
																			<tr>
																				<th>No</th>
																				<th>Kategori</th>
																				<th>Aksi</th>
																			</tr>     
																		</thead>
																		<tbody>
																			<tr v-for="(ref, index) in lstkategori" :key="ref">
																				<td class="text-center">{{ index + 1 }}</td>
																				<td>
																					<!-- <input class="form-control" type="text" v-model="ref.nama_kat"> -->
																					<v-select
																					:options="lstkat"
																					:reduce="lstkat => lstkat.id" 
																					label="nama_kat"
																					v-model="ref.id_kat"                                
																					/>
																				</td>										
																				<td class="text-center">
																					<v-btn color="btn btn-sm bg-danger-light" depressed small @click="deleteKategori(index)">
																						<i class="fas fa-times"></i> Delete
																					</v-btn>
																				</td>
																			</tr>
																			
																		</tbody>  	
																	</table>																	
																</div>
															</div>
															
															<div class="col-md-12 col-sm-12">
																<hr>
																<div class="table-responsive">		
																		
																	<h3>JIKA SUDAH BELI PAKET</h3>		
																	
																	<div class="col-md-6 col-sm-12">
																		<div class="form-group card-label">
																			<label>Harga Special</label>
																			<number class="form-control" v-model="paket.harga_special" v-bind="number"></number>
																		</div>
																	</div>														
																	<div class="col-auto text-right float-right ml-auto">
																		<a href="#" class="btn btn-primary btn-sm" @click.prevent="addRelasiPaket()">Tambah Paket Yang Pernah Dibeli</a>
																	</div>
																	<table id="tbl" class="table table-hover table-center mb-0">
																		<thead>
																			<tr>
																				<th>No</th>
																				<th>Paket</th>
																				<th>Aksi</th>
																			</tr>     
																		</thead>
																		<tbody>
																			<tr v-for="(ref, index) in lstrelasipaket" :key="ref">
																				<td class="text-center">{{ index + 1 }}</td>
																				<td>
																					<!-- <input class="form-control" type="text" v-model="ref.nama_kat"> -->
																					<v-select
																					:options="lstpaket"
																					:reduce="lstpaket => lstpaket.id_paket" 
																					label="nama_paket"
																					v-model="ref.id_paket_parent"                                
																					/>
																				</td>										
																				<td class="text-center">
																					<v-btn color="btn btn-sm bg-danger-light" depressed small @click="deleteRelasiPaket(index)">
																						<i class="fas fa-times"></i> Delete
																					</v-btn>
																				</td>
																			</tr>
																			
																		</tbody>  	
																	</table>																	
																</div>
															</div>
															
															<div class="col-md-12 col-sm-12">
																<hr>
																<div class="table-responsive">		
																		
																	<h3>DAFTAR MITRA</h3>																
																	<div class="col-auto text-right float-right ml-auto">
																		<a href="#" class="btn btn-primary btn-sm" @click.prevent="addMitra()">Tambah Mitra</a>
																	</div>
																	<table id="tbl" class="table table-hover table-center mb-0">
																		<thead>
																			<tr>
																				<th>No</th>
																				<th>Mitra</th>
																				<th>Aksi</th>
																			</tr>     
																		</thead>
																		<tbody>
																			<tr v-for="(ref, index) in paketlstmitra" :key="ref">
																				<td class="text-center">{{ index + 1 }}</td>
																				<td>
																					<!-- <input class="form-control" type="text" v-model="ref.nama_kat"> -->
																					<v-select
																					:options="lstmitra"
																					:reduce="lstmitra => lstmitra.id_user" 
																					label="namauser"
																					v-model="ref.id_mitra"                                
																					/>
																				</td>										
																				<td class="text-center">
																					<v-btn color="btn btn-sm bg-danger-light" depressed small @click="deleteMitra(index)">
																						<i class="fas fa-times"></i> Delete
																					</v-btn>
																				</td>
																			</tr>
																			
																		</tbody>  	
																	</table>																	
																</div>
															</div>

															<!-- <div v-if="paket.tipe_paket=='2'" class="col-md-12 col-sm-12">
																<hr>
																<div class="table-responsive">	
																	<h3>JADWAL BIMBEL</h3>																
																	<div class="col-auto text-right float-right ml-auto">
																		<a href="#" class="btn btn-primary btn-sm" @click.prevent="addJadwal()">Tambah Jadwal</a>
																	</div>
																	<table id="tbl" class="table table-hover table-center mb-0">
																		<thead>
																			<tr>
																				<th>Judul Pertemuan</th>
																				<th>Jadwal</th>
																				<th>Nama Coach</th>
																				<th>Link Pertemuan</th>
																				<th>Link Rekaman</th>
																				<th>Link Materi</th>
																				<th>Aksi</th>
																			</tr>     
																		</thead>
																		<tbody>
																			<tr v-for="(ref, index) in lstjadwal" :key="ref">
																				<td><input class="form-control" type="text" v-model="ref.judul_pertemuan"></td>										
																				<td><input class="form-control" type="datetime-local"  v-model="ref.jadwal_pertemuan"></td>										
																				<td><input class="form-control" type="text" v-model="ref.nama_coach"></td>										
																				<td><input class="form-control" type="text" v-model="ref.link_pertemuan"></td>										
																				<td><input class="form-control" type="text" v-model="ref.link_rekaman"></td>										
																				<td><input class="form-control" type="text" v-model="ref.link_materi"></td>										
																				<td class="text-center">
																					<v-btn color="btn btn-sm bg-danger-light" depressed small @click="deleteJadwal(index)">
																						<i class="fas fa-times"></i>
																					</v-btn>
																				</td>
																			</tr>
																			
																		</tbody>  	
																	</table>																	
																</div>
															</div> -->
															
														</div>
														
														<br>
													</form>
												<!-- </div>
											</div> -->
										<!-- </div> -->
									</div>

									
									<div id="attachtryout" class="tab-pane fade">
										<div class="table-responsive">
											
											<h3>Daftar Latihan</h3>		
											<table id="tblToPaket" class="table table-hover table-center mb-0">
												<thead>
													<tr>
														<th class="text-left">#</th>
														<th class="text-left">Tingkatan / Kategori / Subject</th>
														<th class="text-left">Paket Soal</th>
														<th class="text-left" style="width:150px">Status</th>
														<th class="text-left">Action</th>
													</tr>
												</thead>
							
												<tbody>
													<tr v-for="(ref, index) in paketlsttryout" :key="ref.id_to">
														<td>{{ index + 1 }}</td>
														<td>{{ ref.nama_tingkatan }} / {{ ref.nama_materi }} / {{ ref.nama_sub_materi }}</td>
														<!-- <td> 
															:disabled="!isFormJadwal"
															<v-select  style="width:150px"
															:options="lsttryout"
															:reduce="lsttryout => lsttryout.id_to" 
															label="nama_to"
															v-model="ref.id_to"
															/>
														</td> -->
														<td>{{ ref.nama_to }}</td> 
														<td>
															<v-select style="width:150px"
															:options="lststatusto"
															:reduce="lststatusto => lststatusto.id" 
															label="text"
															v-model="ref.status"
															/>
														</td>
														<td>
															<v-btn class="btn btn-sm bg-success-light" depressed small @click="deattachTo(index, ref)">
																<i class="fas fa-eye"></i> DeAttach
															</v-btn>
														</td>
													</tr>
												</tbody>                                            
											</table>
											<!-- <div class="submit-section text-center">
												<button class="btn btn-primary submit-btn" @click.prevent="addTryout">Add To</button>
											</div> -->
											<br><hr><br>
											
											<h3>Draft Latihan</h3>		
											<table id="tblToDraft" class="table table-hover table-center mb-0">
												<thead>
													<tr>
														<th class="text-left">#</th>
														<th class="text-left">Tingkatan / Kategori / Subject</th>
														<th class="text-left">Paket Soal</th>
														<th class="text-left">Action</th>
													</tr>
												</thead>
							
												<tbody>
													<tr v-for="(ref, index) in lsttryout" :key="ref.id_to">
														<td>{{ index + 1 }}</td>
														<td>{{ ref.nama_tingkatan }} / {{ ref.nama_materi }} / {{ ref.nama_sub_materi }}</td>
														<td>{{ ref.nama_to }}</td>
														<td>
															<v-btn class="btn btn-sm bg-success-light" depressed small @click="attachTo(index, ref)">
																<i class="fas fa-eye"></i> Attach
															</v-btn>
														</td>
													</tr>
												</tbody>                                            
											</table>
										</div>
									</div>

									<div id="attachkategori" class="tab-pane fade">
										<div class="table-responsive">
											
											<h3>Daftar Kategori</h3>		
											<table id="tblKategoriPaket" class="table table-hover table-center mb-0">
												<thead>
													<tr>
														<th class="text-left">#</th>
														<th class="text-left">Tingkatan</th>
														<th class="text-left">Materi</th>
														<th class="text-left">Action</th>
													</tr>
												</thead>
							
												<tbody>
													<tr v-for="(ref, index) in paketlstmateri" :key="ref.id_materi">
														<td>{{ index + 1 }}</td>
														<td>{{ ref.nama_tingkatan }}</td>
														<td>{{ ref.nama_materi }}</td>
														<td>
															<v-btn class="btn btn-sm bg-success-light" depressed small @click="deattachKategori(index, ref)">
																<i class="fas fa-eye"></i> DeAttach
															</v-btn>
														</td>
													</tr>
												</tbody>                                            
											</table>
											<br><hr><br>
											
											<h3>Draft Kategori</h3>		
											<table id="tblKategoriDraft" class="table table-hover table-center mb-0">
												<thead>
													<tr>
														<th class="text-left">#</th>
														<th class="text-left">Tingkatan</th>
														<th class="text-left">Materi</th>
														<th class="text-left">Action</th>
													</tr>
												</thead>
							
												<tbody>
													<tr v-for="(ref, index) in lstmateri" :key="ref.id_materi">
														<td>{{ index + 1 }}</td>
														<td>{{ ref.nama_tingkatan }}</td>
														<td>{{ ref.nama_materi }}</td>
														<td>
															<v-btn class="btn btn-sm bg-success-light" depressed small @click="attachKategori(index, ref)">
																<i class="fas fa-eye"></i> Attach
															</v-btn>
														</td>
													</tr>
												</tbody>                                            
											</table>
										</div>
									</div>

								</div>	
							<!-- </div>
						</div> -->

					</div>
					<div class="modal-footer">
						<div class="submit-section text-center">
							<button class="btn btn-primary submit-btn" @click.prevent="save">Simpan Paket</button>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div id="jadwalMdl" class="modal custom-modal fade" role="dialog">
			<div class="modal-dialog modal-dialog-centered modal-xl" role="document" style="width:90% !important">
				<div class="modal-content">
					<div class="modal-header">
						<h4 class="modal-title">Manajemen Jadwal | Paket {{paket.nama_paket}}</h4>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<form id="frm">                            
                            <div class="row">
                                <div class="col-md-6 col-sm-12">
                                    <div class="form-group card-label">
                                        <label>Judul Pertemuan</label>
                                        <input :disabled="!isFormJadwal" class="form-control" type="text" v-model="paketjadwal.judul_pertemuan">
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-12">
                                    <div class="form-group card-label">
                                        <label>Jadwal Pertemuan</label>
                                        <input :disabled="!isFormJadwal" class="form-control" type="datetime-local" v-model="paketjadwal.jadwal_pertemuan">
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-12">
                                    <div class="form-group card-label">
                                        <label>Nama Coach</label>
                                        <input :disabled="!isFormJadwal" class="form-control" type="text" v-model="paketjadwal.nama_coach">
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-12">
                                    <div class="form-group card-label">
                                        <label>Link Pertemuan</label>
                                        <input :disabled="!isFormJadwal" class="form-control" type="text" v-model="paketjadwal.link_pertemuan">
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-12">
                                    <div class="form-group card-label">
                                        <label>Link Rekaman</label>
                                        <input :disabled="!isFormJadwal" class="form-control" type="text" v-model="paketjadwal.link_rekaman">
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-12">
                                    <div class="form-group card-label">
                                        <label>Link Materi</label>
                                        <input :disabled="!isFormJadwal" class="form-control" type="text" v-model="paketjadwal.link_materi">
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-12">
                                    <div class="form-group card-label">
                                        <label>Pre Test</label>
                                        <v-select :disabled="!isFormJadwal"
                                        :options="lsttryoutjadwal"
                                        :reduce="lsttryoutjadwal => lsttryoutjadwal.id_to" 
                                        label="nama_to"
                                        v-model="paketjadwal.pretest"
                                        />
                                        
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-12">
                                    <div class="form-group card-label">
                                        <label>Post Test</label>
                                        <v-select :disabled="!isFormJadwal"
                                        :options="lsttryoutjadwal"
                                        :reduce="lsttryoutjadwal => lsttryoutjadwal.id_to" 
                                        label="nama_to"
                                        v-model="paketjadwal.posttest"
                                        />
                                        
                                    </div>
                                </div>

                            </div>
                            <div class="submit-section text-center" v-if="isFormJadwal">
                                <button class="btn btn-info btn-sm" @click.prevent="saveJadwal">Simpan</button>
                                <button class="btn btn-danger btn-sm" @click.prevent="resetJadwal">Reset</button>
                            </div>
							<hr>

                        </form>

						<div class="table-responsive">	
							<!-- <h3>JADWAL BIMBEL</h3>																 -->
							<div class="col-auto text-right float-right ml-auto">
								<a href="#" class="btn btn-primary btn-sm" @click.prevent="addJadwal()"><i class="fa fa-plus"></i></a>
							</div>
							<table id="tblJadwal" class="table table-hover table-center mb-0">
								<thead>
									<tr>
										<!-- <th>Pertemua Ke</th> -->
										<th rowspan="2">Judul</th>
										<th rowspan="2">Jadwal</th>
										<th rowspan="2">Nama Coach</th>
										<th colspan="3">Link</th>
										<th rowspan="2">Status</th>
										<th rowspan="2">Aksi</th>
									</tr> 
									<tr>										
										<th>Pertemuan</th>
										<th>Rekaman</th>
										<th>Materi</th>
									</tr>    
								</thead>
								<tbody>
									<tr v-for="(ref, index) in lstjadwal" :key="ref">
										<!-- <td class="text-center">{{ index + 1 }}</td> -->
										<td>{{ref.judul_pertemuan}}</td>										
										<td>{{ref.jadwal_pertemuan_lbl}}</td>										
										<td>{{ref.nama_coach}}</td>										
										<!-- <td>{{ref.link_pertemuan}}</td>										
										<td>{{ref.link_rekaman}}</td>										
										<td>{{ref.link_materi}}</td> -->
										<td class="text-center">
											<span :class="{'badge badge-pill': true, 'bg-warning-light' : ref.link_pertemuan == '-' , 'bg-success-light' : ref.link_pertemuan != '-'}"><i :class="{'fas': true, 'fa-times' : ref.link_pertemuan == '-' , 'fa-check' : ref.link_pertemuan != '-'}"></i></span>
										</td>
										<td class="text-center">
											<span :class="{'badge badge-pill': true, 'bg-warning-light' : ref.link_rekaman == '-' , 'bg-success-light' : ref.link_rekaman != '-'}"><i :class="{'fas': true, 'fa-times' : ref.link_rekaman == '-' , 'fa-check' : ref.link_rekaman != '-'}"></i></span>
										</td>	
										<td class="text-center">
											<span :class="{'badge badge-pill': true, 'bg-warning-light' : ref.link_materi == '-' , 'bg-success-light' : ref.link_materi != '-'}"><i :class="{'fas': true, 'fa-times' : ref.link_materi == '-' , 'fa-check' : ref.link_materi != '-'}"></i></span>
										</td>											
										<td class="text-center">{{ref.status_lbl}} 
											<br>
											<v-btn v-if="ref.status_jadwal=='0'"  color="btn btn-xs bg-warning-light" depressed small @click="closedJadwal(ref, 1)">
												<i class="fas fa-eye"></i>
											</v-btn>
											<v-btn v-if="ref.status_jadwal=='1'"  color="btn btn-xs bg-danger-light" depressed small @click="closedJadwal(ref, 0)">
												<i class="fas fa-eye-slash"></i>
											</v-btn>
										</td>										
										<!-- <td><input class="form-control" type="text" v-model="ref.judul_pertemuan"></td>										
										<td><input class="form-control" type="datetime-local"  v-model="ref.jadwal_pertemuan"></td>										
										<td><input class="form-control" type="text" v-model="ref.nama_coach"></td>										
										<td><input class="form-control" type="text" v-model="ref.link_pertemuan"></td>										
										<td><input class="form-control" type="text" v-model="ref.link_rekaman"></td>										
										<td><input class="form-control" type="text" v-model="ref.link_materi"></td>										
										 -->
										<td class="text-center">
											<v-btn color="btn btn-xs bg-info-light" depressed small @click="editJadwal(ref)">
												<i class="fas fa-edit"></i>
											</v-btn>
											<!-- <v-btn v-if="ref.status_jadwal=='0'"  color="btn btn-xs bg-warning-light" depressed small @click="closedJadwal(ref)">
												<i class="fas fa-check"></i>
											</v-btn> -->
											<v-btn v-if="ref.status_jadwal=='0'" color="btn btn-xs bg-danger-light" depressed small @click="deleteJadwal(index)">
												<i class="fas fa-times"></i>
											</v-btn>
										</td>
									</tr>
									
								</tbody>  	
							</table>																	
						</div>
					</div>
					<!-- <div class="modal-footer">
						<div class="submit-section text-center">
							<button class="btn btn-primary submit-btn" @click.prevent="saveJadwal">Simpan Jadwal</button>
						</div>
					</div> -->
				</div>
			</div>
		</div>

		
        <div id="ldtMdl" class="modal custom-modal fade" role="dialog">
            <div class="modal-dialog modal-dialog-centered modal-xl"  role="document" style="width:90% !important">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">LearnDoTeach | Paket {{paket.nama_paket}}</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
						
						<div class="card card-table">
							<div class="card-body p-3">
								<div class="row text-center">
									<div class="col-md-6">
										<div class="form-group card-label">
											<!-- <label>Paket Bimbel</label> -->
											<v-select
											:options="lstjadwal"
											:reduce="lstjadwal => lstjadwal.id_paket_jadwal" 
											label="judul_pertemuan"
											v-model="id_paket_jadwal"
											placeholder="Silahkan pilih Jadwal Pertemuan"
											required
											/>
											
										</div>
									</div>
									<div class="col-md-3 ">
										<button class="btn btn-primary btn-sm float-left" @click.prevent="getLdtSiswa()"> Lihat Hasil LearnDiTeach </button>
									</div>
								</div>
							</div>
						</div>

						<div class="card card-table mb-0">
							<div class="card-body">
								
								<div class="table-responsive">
									<table id="tblLdt" class="table table-hover table-center mb-0">
										<thead>
											<tr>
												<th class="text-left">#</th>
												<!-- <th class="text-left">Paket Bimbel</th> -->
												<th class="text-left">Nama Peserta</th>
												<th class="text-left">Jumlah Soal</th>
												<th class="text-left">Action</th>
											</tr>
										</thead>
					
										<tbody>
											
											<tr v-for="(ref, index) in lstldtsiswa" :key="ref.id_to">
												<td>{{ index + 1 }}</td>
												<!-- <td>{{ ref.nama_paket }}</td> -->
												<td>{{ ref.namauser }}</td>
												<td class="text-center">{{ ref.jumlah_soal }}</td>
												<td>
													<v-btn class="btn btn-sm bg-warning-light" depressed small @click="getPreview(ref)">
														<i class="fas fa-eye"></i> Preview Soal
													</v-btn>
												</td>
											</tr>
										</tbody>                                            
									</table>
									
								</div>
							</div>
						</div>
						<br><hr><br>
                       <div class="row" v-if="lstsoal.length">
						    <br><br>
                            <div class="comp-header p-3"><h3 class="comp-title">LearnDoTeach | Peserta {{ldt.namauser}}</h3> <div class="line"></div></div>

                            <div class="col-md-12" v-for="(ref, index) in lstsoal" :key="ref.soal.id_soal">
                                <div class="card">
                                    <div class="card-header">
                                        <div class="login-header">
                                            <h3>Soal Nomor {{index+1}}
                                                <!-- <button v-if="ref.soal.ket_laporan" class="btn btn-rounded float-right" :class="{'btn-outline-danger': !ref.soal.ket_laporan, 'btn-outline-warning': ref.soal.ket_laporan}" @click="getLaporan()"><i class="fa fa-info-circle"></i> {{ref.soal.ket_laporan ? "Lihat laporan soal":""}} </button> -->
                                            </h3>
                                        </div>
                                    </div>
                                    <!-- Checkout Form -->
                                    <div class="card-body">
                                
                                        <!-- Personal Information -->
                                        <div class="info-widget">

                                            <div class="row">
                                                <div class="col-md-12 col-sm-12">
                                                    <div class="titleContainer title " v-html="ref.soal.uraian_soal"></div>

                                                    <!-- quizOptions -->
                                                    <div class="optionContainer">
                                                    <!-- <tr v-for="(opsi,i) in this.list_jawaban" :key="opsi.id_jawaban"> -->

                                                        <div class="option" v-for="(response, idx) in ref.list_jawaban" :key="idx"
                                                       
                                                        :class="{ 'bg-info-light': (response.poin >0)}">
                                                            {{ response.jawaban }}. {{ response.uraian_jawaban }}
                                                            <button class="float-right">
                                                                <span >Poin Jawaban : {{response.poin}}</span> &nbsp;
                                                                <i class="fa" 
                                                                :class="{'fa-check':response.poin > 0}"
                                                                ></i> </button>
                                                            
                                                        </div>
                                                    </div>
                                                    
                                                </div>
                                            </div>

                                            
                                        </div>

                                        <div>
                                            <div class="login-header">
                                                    <h3>Pembahasan</h3>
                                            </div>
                                            <div class="alert alert-warning " v-html="ref.soal.pembahasan"></div>

                                            <!-- <button class="btn btn-rounded btn-outline-primary" @click.prevent="selectOption(-1)">Kosongkan Jawaban</button> -->
                                        </div>
                                    </div>
                                    <!-- /Checkout Form -->
                                </div>
                                
                            </div>
                       </div>
                    </div>
                </div>
            </div>
        </div>

		
        <div id="delMdl" class="modal custom-modal fade" role="dialog">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Hapus Paket</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form>
                            <div class="form-group">
                                <label>Apakah anda yakin akan menghapus paket <b>{{ paket.nama_paket }}</b></label>
                            </div>
                            <div class="submit-section">
                                <button class="btn btn-primary submit-btn" @click.prevent="hapus">Yakin</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>


	</div>
		<!-- /Main Wrapper -->
</template>


<script>
import Sidebar from '../Sidebar'
import axios from 'axios';
import 'jquery/dist/jquery.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import $ from 'jquery'
import Number  from 'vue-number-format'

export default {
    components: {
        Sidebar, Number
    },
	name: 'kelas-saya',
    // vuetify: new Vuetify(),
    data() {
        return {
			number: {
				decimal: '.',
				separator: ',',
				prefix: 'I ',
				// suffix: ' #',
				precision: 0,
				masked: false
			},
            lstpaket: [], lstkat: [], 
            paket:{
                id_paket: '',
                nama_paket: '',
                tipe_paket: '',
                harga_awal: 0,
                diskon: '',
				harga_aktif: '',
                masa_berlaku: '',
				jml_to: '',
                diskon_referral: '',
                komisi_referral: '',
                url_gambar: '',
                fg_publish: '',
                fg_pendaftaran: '',
                fg_favorit: '',
                fg_rank: '',
                fg_slot: '',
                url_telegram: '',
                slot: '',
				deskripsi: '',
				id_kat: '',
				id_mitra: ''
            },
            lsttipe: [
                {id: '1', text: 'MANDIRI'},
                {id: '2', text: 'BIMBEL'}
            ],
            lststspublish: [
                {id: '1', text: 'DRAFT'},
                {id: '2', text: 'PUBLISH'}
            ],
            lststspendaftaran: [
                {id: '1', text: 'DITUTUP'},
                {id: '2', text: 'DIBUKA'}
            ],
            lststsfav: [
                {id: '1', text: 'TIDAK'},
                {id: '2', text: 'YA'}
            ],
			lstbenefit: [],
			lstjadwal: [],
			lsttryout: [],
			paketlsttryout: [],
			lstmateri: [],
			paketlstmateri: [],
            lststatusto: [
                {id: '0', text: 'Normal'},
                {id: '1', text: 'Pre Test'},
                {id: '2', text: 'Post Test'},
            ],
			paketjadwal:{
				id_paket_jadwal: '',
                judul_pertemuan: '',
                jadwal_pertemuan: '',
                nama_coac: '',
                link_pertemuan: '',
                link_rekaman: '',
				link_materi: '',
                pretest: '',
				posttest: '',
				status_jadwal: '',
            },
			refpaketjadwal:{
				id_paket_jadwal: '',
                judul_pertemuan: '',
                jadwal_pertemuan: '',
                nama_coac: '',
                link_pertemuan: '',
                link_rekaman: '',
				link_materi: '',
                pretest: '',
				posttest: '',
				status_jadwal: 0
            },
			isFormJadwal: false,
			lsttryoutjadwal: [],
			id_paket_jadwal:"",
			lstldtsiswa: [],
			lstsoal: [],
			ldt: [],
			nama_user:"",
			lstkategori: [], lstrelasipaket: [], lstmitra:[], paketlstmitra:[]
        }
    },

    created: function () {
        this.getAll();
		this.getAllKategori();
		this.getAllMitra();
		this.paketlsttryout = [];
		this.paketlstmateri = [];
    },  

    methods: {		
		stripTheGarbage(e) {
			if (e.keyCode < 48 && e.keyCode !== 46 || e.keyCode > 59) {
				e.preventDefault()
			}
		},
		
		initDt(tbId) {
           setTimeout(() => {
                $('#'+tbId).DataTable({
                    "pagingType": "full_numbers",
                    "bLengthChange": false,
                    pageLength : 8,
                    // "lengthMenu": [
                    //     [10, 25, 50, -1],
                    //     [10, 25, 50, "All"]
                    // ],
                    // order: [[0, 'asc'], [3, 'desc']],
                    responsive: true,
                    destroy: true,
                    retrieve: true,
                    autoFill: true,
                    colReorder: true,
					"bSort": false

                });
               }, 300)
        },

        clearTbl(tbId){
            // $('#'+tbId).DataTable();
            var table = $('#'+tbId).DataTable();
            table.destroy();
        },

        reloadTbl(tbId){

            // dT.destroy();
            $('#'+tbId).DataTable();
            $('#'+tbId).destroy();
            this.initDt('#'+tbId);
            // $('#'+tbId).ajax.reload();
        },

        // Get Product
        getAll: function () {
            axios.get('api/paket')
                .then(res => {
                    // console.log(res.data);
                    this.clearTbl("tbl");
                    this.lstpaket = res.data.data;
					// console.log(res.data.data);
                    this.initDt("tbl");

                    // this.clearTbl("tblToPaket");
                    // this.clearTbl("tblKategoriPaket");
                    // this.clearTbl("tblToDraft");
                    // this.clearTbl("tblKategoriDraft");
                    // this.initDt("tblToPaket");
                    // this.initDt("tblKategoriPaket");
                    // this.initDt("tblToDraft");
                    // this.initDt("tblKategoriDraft");
					
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

		getEditPaket: function (id_paket) {
            axios.get('api/paket/'+id_paket)
                .then(res => {
                    // console.log(res.data);
                    // this.clearTbl("tbl");
                    this.paket = res.data.data;

					this.lstbenefit = this.paket.list_benefit;
					// this.lstjadwal = this.paket.list_jadwal;
					this.paketlsttryout = this.paket.list_tryout;
					this.paketlstmateri = this.paket.list_materi;
					this.lstkategori = this.paket.list_kategori;
					this.lstrelasipaket = this.paket.list_relasi_paket;
					this.paketlstmitra = this.paket.list_mitra;
					
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },
 
        // Create New product
        save: function () {
            axios.post('api/paket', {
                    id_paket: this.paket.id_paket,
                    nama_paket: this.paket.nama_paket,
                    tipe_paket: this.paket.tipe_paket,
                    harga_awal: this.paket.harga_awal,
                    harga_special: this.paket.harga_special,
                    diskon: this.paket.diskon,
                    masa_berlaku: this.paket.masa_berlaku,
                    diskon_referral: this.paket.diskon_referral,
                    komisi_referral: this.paket.komisi_referral,
                    url_gambar: this.paket.url_gambar,
                    fg_publish: this.paket.fg_publish,
                    fg_pendaftaran: this.paket.fg_pendaftaran,
                    fg_favorit: this.paket.fg_favorit,
                    fg_rank: this.paket.fg_rank,
                    fg_slot: this.paket.fg_slot,
                    url_telegram: this.paket.url_telegram,
                    slot: this.paket.slot,
					id_kat: this.paket.id_kat,
                    deskripsi: this.paket.deskripsi,
					id_mitra: this.paket.id_mitra,
					lstbenefit: this.lstbenefit,
					lstjadwal: this.lstjadwal,
					lsttryout: this.paketlsttryout,
					lstmateri: this.paketlstmateri,
					lstkategori: this.lstkategori,
					lstrelasipaket: this.lstrelasipaket,
					lstmitra: this.paketlstmitra
                })
                .then(res => {
                    // handle success
                    this.getAll();
                    this.resetVar();
                    $("#addMdl").modal('hide');
                    // this.refreshAll();
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

		
		resetJadwal: function () {
			this.paketjadwal = [];
			this.isFormJadwal = false;
		},
		
		addJadwal: function () {
			this.paketjadwal = this.refpaketjadwal;
			this.isFormJadwal = true;
		},

		editJadwal: function (ref) {
			this.paketjadwal = ref;
			this.isFormJadwal = true;

		},

		closedJadwal: function (ref, status) {
			axios.post('api/paketjadwalstatus', {
                    id_paket: this.paket.id_paket,
					id_paket_jadwal: ref.id_paket_jadwal,
					status_jadwal: status
                })
                .then(res => {
                    // handle success
					this.clearTbl("tblJadwal");
					this.getEditPaket(this.paket.id_paket);
                    this.initDt("tblJadwal");
					this.isFormJadwal = false;
					this.paketjadwal = [];
                    // this.refreshAll();
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
		},

		saveJadwal: function (paketjadwal) {
            axios.post('api/paketjadwal', {
                    id_paket: this.paket.id_paket,
					paketjadwal: this.paketjadwal,
                })
                .then(res => {
                    // handle success
					this.clearTbl("tblJadwal");
					this.getEditPaket(this.paket.id_paket);
                    this.initDt("tblJadwal");
					this.isFormJadwal = false;
					this.paketjadwal = [];
                    // this.refreshAll();
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

        addBenefit: function(){
			if(!Array.isArray(this.lstbenefit)) this.lstbenefit = [];
			this.lstbenefit.push({ id_paket:this.paket.id_paket, nama_paket: '' });
		},

		deleteBenefit: function(index){
			this.lstbenefit.splice(index, 1);
		},

        addKategori: function(){
			if(!Array.isArray(this.lstkategori)) this.lstkategori = [];
			this.lstkategori.push({ id_paket:this.paket.id_paket, nama_paket: '' });
		},

		deleteKategori: function(index){
			this.lstkategori.splice(index, 1);
		},

        addMitra: function(){
			if(!Array.isArray(this.paketlstmitra)) this.paketlstmitra = [];
			this.paketlstmitra.push({ id_paket:this.paket.id_paket, id_mitra: '' });
		},

		deleteMitra: function(index){
			this.paketlstmitra.splice(index, 1);
		},

        addRelasiPaket: function(){
			if(!Array.isArray(this.lstrelasipaket)) this.lstrelasipaket = [];
			this.lstrelasipaket.push({ id_paket:this.paket.id_paket, id_paket_parent: '' });
		},

		deleteRelasiPaket: function(index){
			this.lstrelasipaket.splice(index, 1);
		},

        // addJadwal: function(){
		// 	this.lstjadwal.push({ id_paket:this.paket.id_paket, nama_jadwal: '' });
		// },

		deleteJadwal: function(index){
			this.lstjadwal.splice(index, 1);
		},
		
		addTryout: function(){	
						
			// const tryout = {"id_to": '', "status": ''};
			this.paketlsttryout.push({ id_to:"", status: "" });
		},

        attachTo: function(index, ref){			
			// this.clearTbl("tblToPaket");
			// this.clearTbl("tblToDraft");
			// ref.status = "0";
			// console.log(ref);
			// Object.assign(this.paketlsttryout, ref);
			if(!Array.isArray(this.paketlsttryout)) this.paketlsttryout = [];
			this.paketlsttryout.push(ref);
			// console.log(this.paketlsttryout);
			this.lsttryout.splice(index, 1);
			// this.initDt("tblToPaket");
			// this.initDt("tblToDraft");
		},

		deattachTo: function(index, ref){					
			// this.clearTbl("tblToPaket");
			// this.clearTbl("tblToDraft");
			// ref.status = "0";
			this.paketlsttryout.splice(index, 1);
			this.lsttryout.push(ref);
			// this.initDt("tblToPaket");
			// this.initDt("tblToDraft");
		},

        attachKategori: function(index, ref){			
			// this.clearTbl("tblKategoriPaket");
			// this.clearTbl("tblKategoriDraft");
			if(!Array.isArray(this.paketlstmateri)) this.paketlstmateri = [];

			this.paketlstmateri.push(ref);
			this.lstmateri.splice(index, 1);
			// this.initDt("tblKategoriPaket");
			// this.initDt("tblKategoriDraft");
		},

		deattachKategori: function(index, ref){					
			// this.clearTbl("tblKategoriPaket");
			// this.clearTbl("tblKategoriDraft");
			this.paketlstmateri.splice(index, 1);
			this.lstmateri.push(ref);
			// this.initDt("tblKategoriPaket");
			// this.initDt("tblKategoriDraft");
		},

        resetVar: function(ref){
            if(ref){
				this.paket.id_paket = ref.id_paket;
				this.paket.nama_paket = ref.nama_paket;
				this.paket.tipe_paket = ref.tipe_paket;
				this.paket.harga_awal = ref.harga_awal;
				this.paket.diskon = ref.diskon;
				this.paket.masa_berlaku = ref.masa_berlaku;
				this.paket.diskon_referral = ref.diskon_referral;
				this.paket.komisi_referral = ref.komisi_referral;
				this.paket.url_gambar = ref.url_gambar;
				this.paket.fg_publish = ref.fg_publish;
				this.paket.fg_pendaftaran = ref.fg_pendaftaran;
				this.paket.fg_favorit = ref.fg_favorit;
				this.paket.fg_rank = ref.fg_rank;
				this.paket.fg_slot = ref.fg_slot;
				this.paket.url_telegram = ref.url_telegram;
				this.paket.slot = ref.slot;
				this.paket.id_kat = ref.id_kat;
				this.paket.deskripsi = ref.deskripsi;
				this.paket.id_mitra = ref.id_mitra;
				if(ref.list_benefit) this.lstbenefit = ref.list_benefit;
				else this.lstbenefit = [];
				if(ref.list_jadwal) this.lstjadwal = ref.list_jadwal;
				else this.lstjadwal = [];

				this.lsttryout = [];
                // this.clearTbl("tblToPaket");
				if(ref.list_tryout) this.paketlsttryout = ref.list_tryout;
				else this.paketlsttryout = [];
                // this.initDt("tblToPaket");
				
				this.lstmateri = [];
                // this.clearTbl("tblKategoriPaket");
				if(ref.list_materi) this.paketlstmateri = ref.list_materi;
				else this.paketlstmateri = [];
                // this.initDt("tblKategoriPaket");
				
				if(ref.list_kategori) this.lstkategori = ref.list_kategori;
				else this.lstkategori = [];
				
				if(ref.list_relasi_paket) this.lstrelasipaket = ref.list_relasi_paket;
				else this.lstrelasipaket = [];
				
				if(ref.list_mitra) this.paketlstmitra = ref.list_mitra;
				else this.paketlstmitra = [];
				

            } else {
				this.paket.id_paket = '';
				this.paket.nama_paket = '';
				this.paket.tipe_paket = '';
				this.paket.harga_awal = '';
				this.paket.harga_special = '';
				this.paket.diskon = '';
				this.paket.masa_berlaku = '';
				this.paket.diskon_referral = '';
				this.paket.komisi_referral = '';
				this.paket.url_gambar = '';
				this.paket.fg_publish = '';
				this.paket.fg_pendaftaran = '';
				this.paket.fg_favorit = '';
				this.paket.fg_rank = '';
				this.paket.fg_slot = '';
				this.paket.url_telegram = '';
				this.paket.slot = '';
				this.paket.id_kat = '';
				this.paket.deskripsi = '';
				this.paket.id_mitra = '';
				this.lstbenefit = [];
				this.lstjadwal = [];
				this.paketlsttryout = [];
				this.paketlstmateri = [];
				this.lstkategori = [];
				this.lstrelasipaket = [];
				this.paketlstmitra = [];
            }
        },

		getAdd: function () {
            this.resetVar(null);
            $("#addMdl").modal('show');
        },

        // Get Edit and Show data to Modal
        getEdit: function (ref) {
            // this.resetVar(ref);
			
            // this.clearTbl("tblToDraft");
			this.lsttryout = [];
            // this.initDt("tblToDraft");
            // this.clearTbl("tblKategoriDraft");
			this.lstmateri = [];
            // this.initDt("tblKategoriDraft");
			
            // this.clearTbl("tblToPaket");
			// this.paketlsttryout = [];
            // this.initDt("tblToPaket");
            // this.clearTbl("tblKategoriPaket");
			// this.paketlstmateri = [];
            // this.initDt("tblKategoriPaket");
			

			// this.clearTbl("tblToDraft");
			// this.clearTbl("tblKategoriDraft");
			// this.clearTbl("tblKategoriPaket");
			// this.clearTbl("tblToPaket");
			
			this.lstbenefit = [];
			this.lstkategori = [];			
			this.lstrelasipaket = [];
			this.lstjadwal = [];
			this.paketlsttryout = [];
			this.paketlstmateri = [];
			this.paketlstmitra = [];	
			this.getEditPaket(ref.id_paket);
			this.getAllTryout(ref.id_paket);
			this.getAllMateri(ref.id_paket);
            $("#addMdl").modal('show');
        },

		getLdt: function(ref){
			this.ldt =[];
			this.paket = [];
			this.lstsoal = [];
			this.lstldtsiswa = [];
			this.clearTbl("tblLdt");
            this.initDt("tblLdt");
			this.getEditPaket(ref.id_paket);
            $("#ldtMdl").modal('show');
		},

		getLdtSiswa: function () {

            axios.get('api/ldtsiswabypaketjadwal/'+this.paket.id_paket+'/'+this.id_paket_jadwal)
                .then(res => {
                    // console.log(res.data);
                    this.clearTbl("tblLdt");
                    this.lstldtsiswa = res.data.data;
                    this.initDt("tblLdt");
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

		
        getPreview: function (ref) {
            this.ldt = ref;
			this.lstsoal = []; 
            axios.get('api/ldtpreviewsoal/'+ref.id_user+'/'+ref.id_paket_sales+'/'+ref.id_paket_jadwal) //+this.$route.params.id)
                .then(res => {
                    $("#previewMdl").modal('show');

                    this.lstsoal = res.data.data;
                    // if(this.lstsoal){
                    //     this.setRowSoal(0);
                    // }
                    // console.log(this.lstsoal[0].soal.pembahasan);
                    // this.initDt("tblLatihan");
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

		getJadwal: function (ref) {   
			this.paketjadwal = this.refpaketjadwal;
			this.clearTbl("tblJadwal");
			this.getEditPaket(ref.id_paket);
			this.initDt("tblJadwal");
			this.getAllTryoutJadwal();
            $("#jadwalMdl").modal('show');
        },
 
        // Get Delete and Show Confirm Modal
        getDelete: function (ref) {
            this.resetVar(ref);
            $("#delMdl").modal('show');
        },
 
        // Delete Product
        hapus: function () {
            axios.post('api/paketdel', {
                    id_paket: this.paket.id_paket,
                })
                .then(res => {
                    // handle success
                    this.getAll();
                    this.resetVar();
                    $("#delMdl").modal('hide');

					let timerInterval
                    swal.fire({
                    title: 'Hapus Paket',
                    html: 'Paket berhasil dihapus!',
                    timer: 2000,
                    // icon: 'success',
                    timerProgressBar: true,
                    didOpen: () => {
                        swal.showLoading()
                        const b = swal.getHtmlContainer().querySelector('b')
                        timerInterval = setInterval(() => {
                        b.textContent = swal.getTimerLeft()
                        }, 100)
                    },
                    willClose: () => {
                        clearInterval(timerInterval)
                    }
                    }).then((result) => {
                    /* Read more about handling dismissals below */
                    if (result.dismiss === swal.DismissReason.timer) {
                        console.log('I was closed by the timer')
                    }
                    })
                    // this.refreshAll();
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

		//--------------------------
		
		// GET Tryout
		getAllTryoutJadwal: function () {
            axios.get('api/tryout')
                .then(res => {
                    this.lsttryoutjadwal = res.data.data;
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },


		// GET Tryout
		getAllTryout: function (id_paket) {
            axios.get('api/tryoutpaket/'+id_paket)
                .then(res => {
                    // console.log(res.data);
                    // this.clearTbl("tblToPaket");
                    this.lsttryout = res.data.data;
					// this.paketlsttryout = [];
                    // this.initDt("tblToPaket");
                    // this.initDt("tblToDraft");
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

        //--------------------------
        // Get Materi
        getAllMateri: function (id_paket) {
			
            axios.get('api/materipaket/'+id_paket)
                .then(res => {  
                    this.lstmateri = res.data.data;
					// this.initDt("tblKategoriDraft");

				})
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

		getAllKategori: function () {
			axios.get('kategori')
				.then(res => {
					// console.log(res);
					this.lstkat = res.data.data;
				})
				.catch(err => {
					// handle error
					console.log(err);
				})
		},
		
		getAllMitra: function () {
			axios.get('mitra')
				.then(res => {
					// console.log(res);
					this.lstmitra = res.data.data;
				})
				.catch(err => {
					// handle error
					console.log(err);
				})
		},
 
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Admin/KelasSaya/index.vue